import React from "react";
import MuiCircularProgress from "@mui/material/CircularProgress";
import MuiButton from "@mui/material/Button";

// Source
import * as HelperSrc from "../../HelperSrc";
import * as ModelDocument from "../../model/custom/Document";
import ControllerLocalization from "../../controller/Localization";
import ControllerDocumentConfirm from "../../controller/custom/DocumentConfirm";
import ViewLoader from "../Loader";

let isRendered = false;

const viewPageDocumentConfirm: React.FC = () => {
    // Variable
    const controllerDocumentConfirm = new ControllerDocumentConfirm(isRendered);
    const controllerLocalization = new ControllerLocalization(isRendered);

    // Method
    controllerDocumentConfirm.initializeHook();
    controllerLocalization.initializeHook();

    // Render
    isRendered = true;

    if (controllerLocalization.getStorageMain && controllerDocumentConfirm.getSelectOption && controllerDocumentConfirm.getDataMain) {
        return (
            <div className="view_document_confirm" data-at_id="view_document_confirm">
                <form className="form">
                    <div className="detail">
                        <p>
                            <span>{controllerLocalization.getStorageMain.preview_filename}:</span>
                            {controllerDocumentConfirm.getDataMain.docx_filename}
                        </p>
                    </div>
                    <div className="detail">
                        <p data-at_id="client_name">
                            <span>{controllerLocalization.getStorageMain.client_name}:</span>
                            {controllerDocumentConfirm.getDataMain.client_name}
                        </p>
                    </div>
                    <div className="detail">
                        <p data-at_id="client_industry">
                            <span>{controllerLocalization.getStorageMain.client_industry}:</span>
                            {(() => {
                                return HelperSrc.showSelectedOptionName(
                                    controllerDocumentConfirm.getSelectOption.client_industry,
                                    controllerDocumentConfirm.getDataMain.client_industry
                                );
                            })()}
                        </p>
                    </div>
                    <div className="detail">
                        <p data-at_id="project_name">
                            <span>{controllerLocalization.getStorageMain.project_name}:</span>
                            {controllerDocumentConfirm.getDataMain.project_name}
                        </p>
                    </div>
                    <div className="detail">
                        <p data-at_id="reporting_year">
                            <span>{controllerLocalization.getStorageMain.reporting_year}:</span>
                            {controllerDocumentConfirm.getDataMain.reporting_year}
                        </p>
                    </div>
                    <div className="detail">
                        <p>
                            <span>{controllerLocalization.getStorageMain.template_type_language}:</span>
                            {controllerDocumentConfirm.getDataMain.template_language}
                        </p>
                    </div>
                    <p className="section_name">{controllerDocumentConfirm.getDataMain.section_data.basic_info[0]}</p>
                    <table>
                        <colgroup>
                            <col className="cell label" />
                            <col className="cell value" />
                        </colgroup>
                        <tbody>
                            {(() => {
                                const html: JSX.Element[] = [];

                                for (const [key, data] of Object.entries(controllerDocumentConfirm.getDataMain.section_data.basic_info)) {
                                    if (parseInt(key) > 0) {
                                        const alternateRow = Number(key) % 2 === 1 ? "even" : "";

                                        html.push(
                                            <tr className={`row ${alternateRow}`}>
                                                <td className="cell">{data.item}</td>
                                                <td className="cell" data-at_id={`basic_info_${key}`}>
                                                    {data.value}
                                                </td>
                                            </tr>
                                        );
                                    }
                                }

                                return html;
                            })()}
                        </tbody>
                    </table>
                    <p className="section_name">{controllerDocumentConfirm.getDataMain.section_data.company_1[0]}</p>
                    <table>
                        <colgroup>
                            <col className="cell label" />
                            <col className="cell value" />
                        </colgroup>
                        <tbody>
                            {(() => {
                                const html: JSX.Element[] = [];

                                for (const [key, data] of Object.entries(controllerDocumentConfirm.getDataMain.section_data.company_1)) {
                                    if (parseInt(key) > 0) {
                                        const alternateRow = Number(key) % 2 === 1 ? "even" : "";

                                        html.push(
                                            <tr className={`row ${alternateRow}`}>
                                                <td className="cell">{data.item}</td>
                                                <td className="cell" data-at_id={`company_1_${key}`}>
                                                    {data.value}
                                                </td>
                                            </tr>
                                        );
                                    }
                                }

                                return html;
                            })()}
                        </tbody>
                    </table>
                    <p className="section_name">{controllerDocumentConfirm.getDataMain.section_data.international_company_1[0]}</p>
                    <table>
                        <colgroup>
                            <col className="cell label" />
                            <col className="cell value" />
                        </colgroup>
                        <tbody>
                            {(() => {
                                const html: JSX.Element[] = [];

                                for (const [key, data] of Object.entries(
                                    controllerDocumentConfirm.getDataMain.section_data.international_company_1
                                )) {
                                    if (parseInt(key) > 0) {
                                        const alternateRow = Number(key) % 2 === 1 ? "even" : "";

                                        html.push(
                                            <tr className={`row ${alternateRow}`}>
                                                <td className="cell">{data.item}</td>
                                                <td className="cell" data-at_id={`international_company_1_${key}`}>
                                                    {data.value}
                                                </td>
                                            </tr>
                                        );
                                    }
                                }

                                return html;
                            })()}
                        </tbody>
                    </table>
                    <p className="section_name">{controllerDocumentConfirm.getDataMain.section_data.company_group[0]}</p>
                    <table>
                        <colgroup>
                            <col className="cell label" />
                            <col className="cell value" />
                        </colgroup>
                        <tbody>
                            {(() => {
                                const html: JSX.Element[] = [];

                                for (const [key, data] of Object.entries(controllerDocumentConfirm.getDataMain.section_data.company_group)) {
                                    if (parseInt(key) > 0) {
                                        const alternateRow = Number(key) % 2 === 1 ? "even" : "";

                                        html.push(
                                            <tr className={`row ${alternateRow}`}>
                                                <td className="cell">{data.item}</td>
                                                <td className="cell" data-at_id={`company_group_${key}`}>
                                                    {data.value}
                                                </td>
                                            </tr>
                                        );
                                    }
                                }

                                return html;
                            })()}
                        </tbody>
                    </table>
                    <p className="section_name">{controllerDocumentConfirm.getDataMain.section_data.industry_analysis[0]}</p>
                    <table>
                        <colgroup>
                            <col className="cell label" />
                            <col className="cell value" />
                        </colgroup>
                        <tbody>
                            {(() => {
                                const html: JSX.Element[] = [];

                                for (const [key, data] of Object.entries(controllerDocumentConfirm.getDataMain.section_data.industry_analysis)) {
                                    if (parseInt(key) > 0) {
                                        const alternateRow = Number(key) % 2 === 1 ? "even" : "";

                                        html.push(
                                            <tr className={`row ${alternateRow}`}>
                                                <td className="cell">{data.item}</td>
                                                <td className="cell" data-at_id={`industry_analysis_${key}`}>
                                                    {data.value}
                                                </td>
                                            </tr>
                                        );
                                    }
                                }

                                return html;
                            })()}
                        </tbody>
                    </table>
                    {(() => {
                        const html: JSX.Element[] = [];

                        if (controllerDocumentConfirm.getDataMain.template_type === "tnmm") {
                            html.push(
                                <div>
                                    <p className="section_name">
                                        {controllerDocumentConfirm.getDataMain.section_data.analysis_targeting_international_transaction_1[0]}
                                    </p>
                                    <table>
                                        <colgroup>
                                            <col className="cell label" />
                                            <col className="cell value" />
                                        </colgroup>
                                        <tbody>
                                            {(() => {
                                                const html: JSX.Element[] = [];

                                                for (const [key, data] of Object.entries(
                                                    controllerDocumentConfirm.getDataMain.section_data.analysis_targeting_international_transaction_1
                                                )) {
                                                    if (parseInt(key) > 0) {
                                                        const alternateRow = Number(key) % 2 === 1 ? "even" : "";

                                                        html.push(
                                                            <tr className={`row ${alternateRow}`}>
                                                                <td className="cell">{data.item}</td>
                                                                <td
                                                                    className="cell"
                                                                    data-at_id={`analysis_targeting_international_transaction_1_${key}`}
                                                                >
                                                                    {data.value}
                                                                </td>
                                                            </tr>
                                                        );
                                                    }
                                                }

                                                return html;
                                            })()}
                                        </tbody>
                                    </table>
                                    <p className="section_name">
                                        {controllerDocumentConfirm.getDataMain.section_data.analysis_targeting_international_transaction_2[0]}
                                    </p>
                                    <table>
                                        <colgroup>
                                            <col className="cell label" />
                                            <col className="cell value" />
                                        </colgroup>
                                        <tbody>
                                            {(() => {
                                                const html: JSX.Element[] = [];

                                                for (const [key, data] of Object.entries(
                                                    controllerDocumentConfirm.getDataMain.section_data.analysis_targeting_international_transaction_2
                                                )) {
                                                    if (parseInt(key) > 0) {
                                                        const alternateRow = Number(key) % 2 === 1 ? "even" : "";

                                                        html.push(
                                                            <tr className={`row ${alternateRow}`}>
                                                                <td className="cell">{data.item}</td>
                                                                <td
                                                                    className="cell"
                                                                    data-at_id={`analysis_targeting_international_transaction_2_${key}`}
                                                                >
                                                                    {data.value}
                                                                </td>
                                                            </tr>
                                                        );
                                                    }
                                                }

                                                return html;
                                            })()}
                                        </tbody>
                                    </table>
                                    <p className="section_name">
                                        {controllerDocumentConfirm.getDataMain.section_data.analysis_targeting_international_transaction_3[0]}
                                    </p>
                                    <table>
                                        <colgroup>
                                            <col className="cell label" />
                                            <col className="cell value" />
                                        </colgroup>
                                        <tbody>
                                            {(() => {
                                                const html: JSX.Element[] = [];

                                                for (const [key, data] of Object.entries(
                                                    controllerDocumentConfirm.getDataMain.section_data.analysis_targeting_international_transaction_3
                                                )) {
                                                    if (parseInt(key) > 0) {
                                                        const alternateRow = Number(key) % 2 === 1 ? "even" : "";

                                                        html.push(
                                                            <tr className={`row ${alternateRow}`}>
                                                                <td className="cell">{data.item}</td>
                                                                <td
                                                                    className="cell"
                                                                    data-at_id={`analysis_targeting_international_transaction_3_${key}`}
                                                                >
                                                                    {data.value}
                                                                </td>
                                                            </tr>
                                                        );
                                                    }
                                                }

                                                return html;
                                            })()}
                                        </tbody>
                                    </table>
                                    <p className="section_name">{controllerDocumentConfirm.getDataMain.section_data.other_transaction_tnmm[0]}</p>
                                    <table>
                                        <colgroup>
                                            <col className="cell label" />
                                            <col className="cell value" />
                                        </colgroup>
                                        <tbody>
                                            {(() => {
                                                const html: JSX.Element[] = [];

                                                for (const [key, data] of Object.entries(
                                                    controllerDocumentConfirm.getDataMain.section_data.other_transaction_tnmm
                                                )) {
                                                    if (parseInt(key) > 0) {
                                                        const alternateRow = Number(key) % 2 === 1 ? "even" : "";

                                                        html.push(
                                                            <tr className={`row ${alternateRow}`}>
                                                                <td className="cell">{data.item}</td>
                                                                <td className="cell" data-at_id={`other_transaction_tnmm_${key}`}>
                                                                    {data.value}
                                                                </td>
                                                            </tr>
                                                        );
                                                    }
                                                }

                                                return html;
                                            })()}
                                        </tbody>
                                    </table>
                                </div>
                            );
                        }

                        return html;
                    })()}
                    {(() => {
                        const html: JSX.Element[] = [];

                        if (controllerDocumentConfirm.getDataMain.template_type === "apa") {
                            html.push(
                                <div>
                                    <p className="section_name">{controllerDocumentConfirm.getDataMain.section_data.covered_transaction[0]}</p>
                                    <table>
                                        <colgroup>
                                            <col className="cell label" />
                                            <col className="cell value" />
                                        </colgroup>
                                        <tbody>
                                            {(() => {
                                                const html: JSX.Element[] = [];

                                                for (const [key, data] of Object.entries(
                                                    controllerDocumentConfirm.getDataMain.section_data.covered_transaction
                                                )) {
                                                    if (parseInt(key) > 0) {
                                                        const alternateRow = Number(key) % 2 === 1 ? "even" : "";

                                                        html.push(
                                                            <tr className={`row ${alternateRow}`}>
                                                                <td className="cell">{data.item}</td>
                                                                <td className="cell" data-at_id={`covered_transaction_${key}`}>
                                                                    {data.value}
                                                                </td>
                                                            </tr>
                                                        );
                                                    }
                                                }

                                                return html;
                                            })()}
                                        </tbody>
                                    </table>
                                    <p className="section_name">{controllerDocumentConfirm.getDataMain.section_data.other_transaction[0]}</p>
                                    <table>
                                        <colgroup>
                                            <col className="cell label" />
                                            <col className="cell value" />
                                        </colgroup>
                                        <tbody>
                                            {(() => {
                                                const html: JSX.Element[] = [];

                                                for (const [key, data] of Object.entries(
                                                    controllerDocumentConfirm.getDataMain.section_data.other_transaction
                                                )) {
                                                    if (parseInt(key) > 0) {
                                                        const alternateRow = Number(key) % 2 === 1 ? "even" : "";

                                                        html.push(
                                                            <tr className={`row ${alternateRow}`}>
                                                                <td className="cell">{data.item}</td>
                                                                <td className="cell" data-at_id={`other_transaction_${key}`}>
                                                                    {data.value}
                                                                </td>
                                                            </tr>
                                                        );
                                                    }
                                                }

                                                return html;
                                            })()}
                                        </tbody>
                                    </table>
                                </div>
                            );
                        }

                        return html;
                    })()}
                    {(() => {
                        const html: JSX.Element[] = [];

                        const sectionList: ModelDocument.Isection[] = [];

                        let title = "";

                        for (const [key, data] of Object.entries(controllerDocumentConfirm.getDataMain.section_data.functions)) {
                            if (parseInt(key) === 0) {
                                title = data as unknown as string;
                            } else if (parseInt(key) > 0) {
                                sectionList.push(data);

                                if (sectionList.length === 2) {
                                    const index = parseInt(key) / 2;

                                    html.push(
                                        <div>
                                            <p className="section_name">{`${title.replace("%a", index.toString())}`}</p>
                                            <table>
                                                <colgroup>
                                                    <col className="cell label" />
                                                    <col className="cell value" />
                                                </colgroup>
                                                <tbody>
                                                    {(() => {
                                                        const html: JSX.Element[] = [];

                                                        for (const [keySub, dataSub] of Object.entries(sectionList)) {
                                                            const alternateRow = Number(keySub) % 2 === 0 ? "even" : "";

                                                            html.push(
                                                                <tr className={`row ${alternateRow}`}>
                                                                    <td className="cell">{keySub === "1" ? dataSub.item : ""}</td>
                                                                    <td className="cell" data-at_id={`function_${index}_${keySub}`}>
                                                                        {dataSub.value}
                                                                    </td>
                                                                </tr>
                                                            );
                                                        }

                                                        return html;
                                                    })()}
                                                </tbody>
                                            </table>
                                        </div>
                                    );

                                    sectionList.length = 0;
                                }
                            }
                        }

                        return html;
                    })()}
                    <p className="section_name">{controllerDocumentConfirm.getDataMain.section_data.risk_1[0]}</p>
                    <table>
                        <colgroup>
                            <col className="cell label" />
                            <col className="cell value" />
                        </colgroup>
                        <tbody>
                            {(() => {
                                const html: JSX.Element[] = [];

                                const section = controllerDocumentConfirm.getDataMain.section_data.risk_1 as Record<string, ModelDocument.Isection>;

                                html.push(
                                    <>
                                        <tr className={`row even`}>
                                            <td className="cell"></td>
                                            <td className="cell" data-at_id="risk_1_1">
                                                {section[1].value}
                                            </td>
                                        </tr>
                                        <tr className={`row`}>
                                            <td className="cell">{section[3].item}</td>
                                            <td className="cell" data-at_id="risk_1_2">
                                                {section[2].value}
                                            </td>
                                        </tr>
                                    </>
                                );

                                return html;
                            })()}
                        </tbody>
                    </table>
                    <p className="section_name">{controllerDocumentConfirm.getDataMain.section_data.risk_2[0]}</p>
                    <table>
                        <colgroup>
                            <col className="cell label" />
                            <col className="cell value" />
                        </colgroup>
                        <tbody>
                            {(() => {
                                const html: JSX.Element[] = [];

                                const section = controllerDocumentConfirm.getDataMain.section_data.risk_2 as Record<string, ModelDocument.Isection>;

                                html.push(
                                    <>
                                        <tr className={`row even`}>
                                            <td className="cell"></td>
                                            <td className="cell" data-at_id="risk_2_1">
                                                {section[1].value}
                                            </td>
                                        </tr>
                                        <tr className={`row`}>
                                            <td className="cell">{section[3].item}</td>
                                            <td className="cell" data-at_id="risk_2_2">
                                                {section[2].value}
                                            </td>
                                        </tr>
                                    </>
                                );

                                return html;
                            })()}
                        </tbody>
                    </table>
                    <p className="section_name">{controllerDocumentConfirm.getDataMain.section_data.risk_3[0]}</p>
                    <table>
                        <colgroup>
                            <col className="cell label" />
                            <col className="cell value" />
                        </colgroup>
                        <tbody>
                            {(() => {
                                const html: JSX.Element[] = [];

                                const section = controllerDocumentConfirm.getDataMain.section_data.risk_3 as Record<string, ModelDocument.Isection>;

                                html.push(
                                    <>
                                        <tr className={`row even`}>
                                            <td className="cell"></td>
                                            <td className="cell" data-at_id="risk_3_1">
                                                {section[1].value}
                                            </td>
                                        </tr>
                                        <tr className={`row`}>
                                            <td className="cell">{section[3].item}</td>
                                            <td className="cell" data-at_id="risk_3_2">
                                                {section[2].value}
                                            </td>
                                        </tr>
                                    </>
                                );

                                return html;
                            })()}
                        </tbody>
                    </table>
                    <p className="section_name">{controllerDocumentConfirm.getDataMain.section_data.risk_4[0]}</p>
                    <table>
                        <colgroup>
                            <col className="cell label" />
                            <col className="cell value" />
                        </colgroup>
                        <tbody>
                            {(() => {
                                const html: JSX.Element[] = [];

                                const section = controllerDocumentConfirm.getDataMain.section_data.risk_4 as Record<string, ModelDocument.Isection>;

                                html.push(
                                    <>
                                        <tr className={`row even`}>
                                            <td className="cell"></td>
                                            <td className="cell" data-at_id="risk_4_1">
                                                {section[1].value}
                                            </td>
                                        </tr>
                                        <tr className={`row`}>
                                            <td className="cell">{section[3].item}</td>
                                            <td className="cell" data-at_id="risk_4_2">
                                                {section[2].value}
                                            </td>
                                        </tr>
                                    </>
                                );

                                return html;
                            })()}
                        </tbody>
                    </table>
                    <p className="section_name">{controllerDocumentConfirm.getDataMain.section_data.risk_5[0]}</p>
                    <table>
                        <colgroup>
                            <col className="cell label" />
                            <col className="cell value" />
                        </colgroup>
                        <tbody>
                            {(() => {
                                const html: JSX.Element[] = [];

                                const section = controllerDocumentConfirm.getDataMain.section_data.risk_5 as Record<string, ModelDocument.Isection>;

                                html.push(
                                    <>
                                        <tr className={`row even`}>
                                            <td className="cell"></td>
                                            <td className="cell" data-at_id="risk_5_1">
                                                {section[1].value}
                                            </td>
                                        </tr>
                                        <tr className={`row`}>
                                            <td className="cell">{section[3].item}</td>
                                            <td className="cell" data-at_id="risk_5_2">
                                                {section[2].value}
                                            </td>
                                        </tr>
                                    </>
                                );

                                return html;
                            })()}
                        </tbody>
                    </table>
                    <p className="section_name">{controllerDocumentConfirm.getDataMain.section_data.risk_6[0]}</p>
                    <table>
                        <colgroup>
                            <col className="cell label" />
                            <col className="cell value" />
                        </colgroup>
                        <tbody>
                            {(() => {
                                const html: JSX.Element[] = [];

                                const section = controllerDocumentConfirm.getDataMain.section_data.risk_6 as Record<string, ModelDocument.Isection>;

                                html.push(
                                    <>
                                        <tr className={`row even`}>
                                            <td className="cell"></td>
                                            <td className="cell" data-at_id="risk_6_1">
                                                {section[1].value}
                                            </td>
                                        </tr>
                                        <tr className={`row`}>
                                            <td className="cell">{section[3].item}</td>
                                            <td className="cell" data-at_id="risk_6_2">
                                                {section[2].value}
                                            </td>
                                        </tr>
                                    </>
                                );

                                return html;
                            })()}
                        </tbody>
                    </table>
                    <p className="section_name">{controllerDocumentConfirm.getDataMain.section_data.risk_7[0]}</p>
                    <table>
                        <colgroup>
                            <col className="cell label" />
                            <col className="cell value" />
                        </colgroup>
                        <tbody>
                            {(() => {
                                const html: JSX.Element[] = [];

                                const section = controllerDocumentConfirm.getDataMain.section_data.risk_7 as Record<string, ModelDocument.Isection>;

                                html.push(
                                    <>
                                        <tr className={`row even`}>
                                            <td className="cell"></td>
                                            <td className="cell" data-at_id="risk_7_1">
                                                {section[1].value}
                                            </td>
                                        </tr>
                                        <tr className={`row`}>
                                            <td className="cell">{section[3].item}</td>
                                            <td className="cell" data-at_id="risk_7_2">
                                                {section[2].value}
                                            </td>
                                        </tr>
                                    </>
                                );

                                return html;
                            })()}
                        </tbody>
                    </table>
                    <p className="section_name">{controllerDocumentConfirm.getDataMain.section_data.risk_8[0]}</p>
                    <table>
                        <colgroup>
                            <col className="cell label" />
                            <col className="cell value" />
                        </colgroup>
                        <tbody>
                            {(() => {
                                const html: JSX.Element[] = [];

                                const section = controllerDocumentConfirm.getDataMain.section_data.risk_8 as Record<string, ModelDocument.Isection>;

                                html.push(
                                    <>
                                        <tr className={`row even`}>
                                            <td className="cell"></td>
                                            <td className="cell" data-at_id="risk_8_1">
                                                {section[1].value}
                                            </td>
                                        </tr>
                                        <tr className={`row`}>
                                            <td className="cell">{section[3].item}</td>
                                            <td className="cell" data-at_id="risk_8_2">
                                                {section[2].value}
                                            </td>
                                        </tr>
                                    </>
                                );

                                return html;
                            })()}
                        </tbody>
                    </table>
                    {(() => {
                        const html: JSX.Element[] = [];

                        if (controllerDocumentConfirm.getDataMain.template_type === "tnmm") {
                            html.push(
                                <div>
                                    <p className="section_name">
                                        {controllerDocumentConfirm.getDataMain.section_data.economic_analysis_population[0]}
                                    </p>
                                    <table>
                                        <colgroup>
                                            <col className="cell label" />
                                            <col className="cell value" />
                                        </colgroup>
                                        <tbody>
                                            {(() => {
                                                const html: JSX.Element[] = [];

                                                for (const [key, data] of Object.entries(
                                                    controllerDocumentConfirm.getDataMain.section_data.economic_analysis_population
                                                )) {
                                                    if (parseInt(key) > 0) {
                                                        const alternateRow = Number(key) % 2 === 1 ? "even" : "";

                                                        html.push(
                                                            <tr className={`row ${alternateRow}`}>
                                                                <td className="cell">{data.item}</td>
                                                                <td className="cell" data-at_id={`economic_analysis_population_${key}`}>
                                                                    {data.value}
                                                                </td>
                                                            </tr>
                                                        );
                                                    }
                                                }

                                                return html;
                                            })()}
                                        </tbody>
                                    </table>
                                    <p className="section_name">{controllerDocumentConfirm.getDataMain.section_data.economic_analysis[0]}</p>
                                    <table>
                                        <colgroup>
                                            <col className="cell label" />
                                            <col className="cell value" />
                                        </colgroup>
                                        <tbody>
                                            {(() => {
                                                const html: JSX.Element[] = [];

                                                for (const [key, data] of Object.entries(
                                                    controllerDocumentConfirm.getDataMain.section_data.economic_analysis
                                                )) {
                                                    if (parseInt(key) > 0) {
                                                        const alternateRow = Number(key) % 2 === 1 ? "even" : "";

                                                        html.push(
                                                            <tr className={`row ${alternateRow}`}>
                                                                <td className="cell">{data.item}</td>
                                                                <td className="cell" data-at_id={`economic_analysis_${key}`}>
                                                                    {data.value}
                                                                </td>
                                                            </tr>
                                                        );
                                                    }
                                                }

                                                return html;
                                            })()}
                                        </tbody>
                                    </table>
                                </div>
                            );
                        }

                        return html;
                    })()}
                    {(() => {
                        const html: JSX.Element[] = [];

                        if (controllerDocumentConfirm.getDataMain.template_type === "apa") {
                            html.push(
                                <div>
                                    <p className="section_name">{controllerDocumentConfirm.getDataMain.section_data.asset_analysis[0]}</p>
                                    <table>
                                        <colgroup>
                                            <col className="cell label" />
                                            <col className="cell value" />
                                        </colgroup>
                                        <tbody>
                                            {(() => {
                                                const html: JSX.Element[] = [];

                                                for (const [key, data] of Object.entries(
                                                    controllerDocumentConfirm.getDataMain.section_data.asset_analysis
                                                )) {
                                                    if (parseInt(key) > 0) {
                                                        const alternateRow = Number(key) % 2 === 1 ? "even" : "";

                                                        html.push(
                                                            <tr className={`row ${alternateRow}`}>
                                                                <td className="cell">{data.item}</td>
                                                                <td className="cell" data-at_id={`asset_analysis_${key}`}>
                                                                    {data.value}
                                                                </td>
                                                            </tr>
                                                        );
                                                    }
                                                }

                                                return html;
                                            })()}
                                        </tbody>
                                    </table>
                                </div>
                            );
                        }

                        return html;
                    })()}
                    <p className="section_name">{controllerDocumentConfirm.getDataMain.section_data.transfer_pricing_estimation[0]}</p>
                    <table>
                        <colgroup>
                            <col className="cell label" />
                            <col className="cell value" />
                        </colgroup>
                        <tbody>
                            {(() => {
                                const html: JSX.Element[] = [];

                                for (const [key, data] of Object.entries(
                                    controllerDocumentConfirm.getDataMain.section_data.transfer_pricing_estimation
                                )) {
                                    if (parseInt(key) > 0) {
                                        const alternateRow = Number(key) % 2 === 1 ? "even" : "";

                                        html.push(
                                            <tr className={`row ${alternateRow}`}>
                                                <td className="cell">{data.item}</td>
                                                <td className="cell" data-at_id={`transfer_pricing_estimation_${key}`}>
                                                    {data.value}
                                                </td>
                                            </tr>
                                        );
                                    }
                                }

                                return html;
                            })()}
                        </tbody>
                    </table>
                    <div className="bottom">
                        <div className="button_container">
                            <MuiButton
                                className="button_primary"
                                data-at_id="button_back"
                                disabled={controllerDocumentConfirm.getApiLoadingList.create}
                                onClick={() => {
                                    controllerDocumentConfirm.clickBack();
                                }}
                            >
                                {(() => {
                                    const html: JSX.Element[] = [];

                                    if (controllerDocumentConfirm.getApiLoadingList.create) {
                                        html.push(<MuiCircularProgress className="icon_progress" />);
                                    } else {
                                        html.push(<>{controllerLocalization.getStorageMain.back}</>);
                                    }

                                    return html;
                                })()}
                            </MuiButton>
                            <MuiButton
                                className="button_primary"
                                data-at_id="button_save"
                                disabled={controllerDocumentConfirm.getApiLoadingList.create}
                                onClick={() => {
                                    controllerDocumentConfirm.clickSave();
                                }}
                            >
                                {(() => {
                                    const html: JSX.Element[] = [];

                                    if (controllerDocumentConfirm.getApiLoadingList.create) {
                                        html.push(<MuiCircularProgress className="icon_progress" />);
                                    } else {
                                        html.push(<>{controllerLocalization.getStorageMain.save}</>);
                                    }

                                    return html;
                                })()}
                            </MuiButton>
                        </div>
                    </div>
                </form>
            </div>
        );
    } else {
        return <ViewLoader />;
    }
};

export default viewPageDocumentConfirm;
